import { z } from "zod";

export interface RedisMemoryConfig {
	baseUrl: string;
	ttlSeconds: number;
}

export function loadRedisMemoryConfig(): RedisMemoryConfig {
	const env = validateEnvironment();
	return {
		baseUrl: env.REDIS_MEMORY_ENDPOINT,
		ttlSeconds: Number(env.REDIS_MEMORY_TTL_SECONDS)
	};
}

function validateEnvironment() {
	const envSchema = z.object({
		REDIS_MEMORY_ENDPOINT: z.string({
			required_error:
				"REDIS_MEMORY_ENDPOINT environment variable is missing"
		}),
		REDIS_MEMORY_TTL_SECONDS: z.string({
			required_error:
				"REDIS_MEMORY_TTL_SECONDS environment variable is missing"
		})
	});

	const parsed = envSchema.safeParse(process.env);

	if (!parsed.success) {
		throw new Error(parsed.error.errors.map((e) => e.message).join("\n"));
	}

	return parsed.data;
}
